import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FilterOutlinedSvg from "@ant-design/icons-svg/es/asn/FilterOutlined";
import AntdIcon from "../components/AntdIcon";
var FilterOutlined = function FilterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilterOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FilterOutlined.displayName = 'FilterOutlined';
}
export default /*#__PURE__*/React.forwardRef(FilterOutlined);